import * as types from '../../constants/backoffice/managerConstants';
export const managerList = ({
  page,
  pageLength,
  searchString,
  callback,
  error,
}) => ({
  type: types.MANAGER_LIST_REQUEST,
  page,
  pageLength,
  searchString,
  callback,
  error,
});

export const setManagerList = (list) => ({
  type: types.SET_MANAGER_LIST,
  list,
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const managerInfo = ({
  managerNo,
  callback,
  error,
}) => ({
  type: types.MANAGER_INFO_REQUEST,
  managerNo,
  callback,
  error,
});

export const setManagerInfo = (info) => ({
  type: types.SET_MANAGER_INFO,
  info,
});

export const authGroupList = ({
  callback,
  error,
}) => ({
  type: types.AUTHGROUP_LIST_REQUEST,
  callback,
  error,
});

export const setAuthGroupList = (list) => ({
  type: types.SET_AUTHGROPUN_LIST,
  list,
});

export const departmentList = ({
  callback,
  error,
}) => ({
  type: types.DEPARTMENT_LSIT_REQUEST,
  callback,
  error,
});

export const setDepartmentList = (list) => ({
  type: types.SET_DEPARTMENT_LIST,
  list,
});

export const managerEmailCheck = ({
  email,
  callback,
  error,
}) => ({
  type: types.EMAIL_CHECK,
  email,
  callback,
  error,
});

export const setEmailExists = (emailExists, resultCode) => ({
  type: types.SET_EMAIL_EXISTS,
  emailExists,
  resultCode,
});

export const createAccount = ({
  name,
  email,
  groupNo,
  departmentNo,
  callback,
  error,
}) => ({
  type: types.CREATE_ACCOUNT,
  name,
  email,
  groupNo,
  departmentNo,
  callback,
  error,
});

export const rndChangePassword = ({
  managerNo,
  callback,
  error,
}) => ({
  type: types.RND_CHANGE_PASSWORD,
  managerNo,
  callback,
  error,
});

export const removeTwoFactor = ({
  managerNo,
  callback,
  error,
}) => ({
  type: types.REMOVE_TWOFACTOR,
  managerNo,
  callback,
  error,
});

export const managerInfoUpdate = ({
  managerNo,
  name,
  email,
  groupNo,
  departmentNo,
  enabled,
  callback,
  error,
}) => ({
  type: types.MANAGER_INFO_UPDATE,
  managerNo,
  name,
  email,
  groupNo,
  departmentNo,
  enabled,
  callback,
  error,
});

export const managerSecede = ({
  managerNo,
  callback,
  error,
}) => ({
  type: types.MANAGER_SECEDE,
  managerNo,
  callback,
  error,
});

export const setManagerPagination = (page, totalCount, searchString) => ({
  type: types.SET_MANAGER_PAGINATION,
  page,
  totalCount,
  searchString,
});

export const managerResponseMessage = (resultCode, message) => ({
  type: types.MANAGER_RESPONSE_MESSAGE,
  resultCode,
  message,
});

export const managerTerminateSession = ({
  managerNo,
  callback,
  error,
}) => ({
  type: types.MANAGER_TERMINATE_SESSION,
  managerNo,
  callback,
  error,
});
